/* eslint-disable no-useless-escape */

export const googleUrlRegex = /^https:\/\/drive\.google\.com\/file\/d\/[^\/]+\/view\?usp=[^\/]+$/
export const dropboxUrlRegex = /^https:\/\/www\.dropbox\.com\/scl\/fi\/[^\/]+\/[^\/]+\?rlkey=[^&]+&st=[^&]+&dl=[^&]+$/

export const googleUrlMatchRegex = /^https:\/\/drive\.google\.com\/file\/d\/([^\/]+)\/view\?usp=[^\/]+$/
